import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { AssociatedpackageComponent } from './package/associatedpackage/associatedpackage.component';
import { FloatInputDirectiveForNgModel, FloatInputDirective, TrimDirective } from '../core/float-label.directive';
import { ConfirmModalComponent } from './modals/confirm-modal/confirm-modal.component';
import { AlertModalComponent } from './modals/alert-modal/alert-modal.component';
import { NotificatoinPopupComponent } from './notification-popup/notification-popup.component';
import { SearchComponent } from './search/search.component';
import { FormsModule } from '@angular/forms';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { ShipmentsComponent } from './shipments/shipments.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { SupportrequestNofiticationComponent } from './supportrequest-nofitication/supportrequest-nofitication.component';
import { CustomerSearchComponent } from './Customer/customer-search/customer-search.component';




@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    BreadcrumbsComponent,
    FloatInputDirectiveForNgModel,
    FloatInputDirective,
    ConfirmModalComponent,
    AlertModalComponent,
    NotificatoinPopupComponent,
    SearchComponent,
    ShipmentsComponent, SupportrequestNofiticationComponent,
    CustomerSearchComponent    
    
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    TypeaheadModule.forRoot(),
    BsDatepickerModule.forRoot(),
    PaginationModule.forRoot(),
  ],
  exports: [
    FooterComponent,
    HeaderComponent,
    SidebarComponent,
    BreadcrumbsComponent,
    FloatInputDirectiveForNgModel,
    FloatInputDirective,
    ShipmentsComponent,
    CustomerSearchComponent
  ]
})
export class SharedModule { }
